import { apiConfig } from 'config';
import { ReportType } from '../@types/boost';
import { ReportInterface, ReportPayloadInterface } from '../@types/reports';
import { WrapperService } from './wrapper';

export class ReportService {
  public apiService: WrapperService = new WrapperService();

  public createOrUpdateReport(method: string, apiURL: string, payload: ReportPayloadInterface) {
    const apiParam = {
      method: method,
      baseURL: apiConfig.asset_mgt,
      url: apiURL,
      body: payload
    };
    return this.apiService.httpCall(apiParam);
  }

  public getReport(reportId = 0, ownerId: any) {
    const apiParam = {
      method: 'GET',
      baseURL: apiConfig.asset_mgt,
      url: `/owner/${ownerId}/report/${reportId}`
    };
    return this.apiService.httpCall(apiParam);
  }

  public getReportsList(
    currentRow: number,
    limit: number,
    ownerId: string | null,
    boostGroupIds: any[] = []
  ) {
    const filteredBoostGroups = boostGroupIds.filter(Number);
    const apiParam = {
      method: 'GET',
      baseURL: apiConfig.asset_mgt,
      url: `/owner/${ownerId}/report/all`,
      params: {
        currentRow: currentRow,
        limit: limit,
        ...(filteredBoostGroups.length > 0 && { boostGroupIds: filteredBoostGroups.join(',') })
      }
    };
    return this.apiService.httpCall(apiParam);
  }

  public deleteReport(reportId: number | null, ownerId: number | null) {
    const apiParam = {
      method: 'DELETE',
      baseURL: apiConfig.asset_mgt,
      url: `/owner/${ownerId}/report/${reportId}`
    };
    return this.apiService.httpCall(apiParam);
  }

  public getSplunkReport(report: ReportInterface) {
    const {
      ownerId,
      boostGroupIds,
      startTime,
      endTime,
      relativeStartTime,
      relativeEndTime,
      reportType
    } = report;
    const apiParam = {
      method: 'POST',
      url: `/report`,
      baseURL: apiConfig.asset_mgt,
      body: {
        ownerId,
        boostGroupIds,
        startTime,
        endTime,
        relativeStartTime,
        relativeEndTime,
        reportType
      }
    };
    return this.apiService.httpCall(apiParam);
  }

  public getDashboardReport(
    startTime: any,
    endTime: any,
    relativeStartTime: any,
    relativeEndTime: any,
    ownerId: number | undefined,
    boostGroupIds: any,
    reportType: string,
    clientIds?: any[]
  ): Promise<any> {
    const apiParam = {
      method: 'POST',
      url: `/report`,
      baseURL: apiConfig.asset_mgt,
      body: {
        ownerId,
        boostGroupIds: Array.isArray(boostGroupIds) ? boostGroupIds : [boostGroupIds],
        ...(clientIds && { clientIds }),
        ...(startTime && { startTime }),
        ...(endTime && { endTime }),
        ...(relativeStartTime && { relativeStartTime }),
        ...(relativeEndTime && { relativeEndTime }),
        reportType
      }
    };
    return this.apiService.httpCall(apiParam);
  }

  public getSocInformation(
    startTime: any,
    endTime: any,
    ownerId: any,
    clientIds: any
  ): Promise<any> {
    const apiParam = {
      method: 'POST',
      url: `/report`,
      baseURL: apiConfig.asset_mgt,
      body: {
        ownerId,
        startTime,
        endTime,
        reportType: ReportType.stateOfCharge,
        clientIds: Array.isArray(clientIds) ? clientIds : [clientIds]
      }
    };
    return this.apiService.httpCall(apiParam);
  }

  public getBoostDemandChargeSavings(startTime: any, endTime: any, clientIds: any): Promise<any> {
    const apiParam = {
      method: 'POST',
      url: `/report`,
      baseURL: apiConfig.asset_mgt,
      body: {
        startTime: startTime,
        endTime: endTime,
        clientIds: Array.isArray(clientIds) ? clientIds : [clientIds],
        reportType: ReportType.demandChargeSavings
      }
    };
    return this.apiService.httpCall(apiParam);
  }
}
